import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FclayoutcolComponent } from './fclayoutcol.component';
import { FclayoutgroupComponent } from './fclayoutgroup.component';
import { FclayoutrowComponent } from './fclayoutrow.component';
import { FclayoutpanelComponent } from './fclayoutpanel.component';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule
  ],
  exports: [
    FclayoutcolComponent,
    FclayoutgroupComponent,
    FclayoutrowComponent,
    FclayoutpanelComponent
  ],
  declarations: [
    FclayoutcolComponent,
    FclayoutgroupComponent,
    FclayoutrowComponent,
    FclayoutpanelComponent
  ],
  providers: [

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FclayoutModule { }
